module.exports = __webpack_public_path__ + "img/bg_mask_bg.583f8ba8.svg";